import React, { FunctionComponent } from 'react';
import Tooltip from 'rc-tooltip';
import infoImage from '../../assets/info.png';
import infoInvertedImage from '../../assets/info-inverted.png';
import styles from './styles.module.scss';

interface Props {
  content: string;
  invertedColor?: boolean;
}

export const TooltipIcon: FunctionComponent<Props> = ({
  content,
  invertedColor,
}) => (
  <Tooltip placement="top" overlay={content}>
    <img
      className={styles.tooltipAnchor}
      src={invertedColor ? infoInvertedImage : infoImage}
      alt="Info"
    />
  </Tooltip>
);
